import React from "react";
import { Contact, Header, Hire } from "./Components";

const Tutoring = () => {
  return (
    <div className="servicesPages">
      <Header
        header="Get Tutoring Services for Writing CDR, RPL, and KA02 Reports"
        desc="Simplify your report preparation process by leveraging expert tutoring services. Start by addressing the specific requirements of your document and skillfully navigate through the complexities involved in the review process."
      />
      <div className="body">
        <div>
          <div className="header">1-to-1 Tutoring Service</div>
          <div className="desc">
            Our CDR tutoring service provides personalized online sessions with expert tutors to guide you through the process of CDR Writing for Engineers Australia. These
            sessions are designed to help engineers and ICT professionals create high-quality CDR reports for skilled migration to Australia. Our team is highly experienced in
            preparing CDRs that adhere to Engineers Australia's requirements, offering detailed instructions and insights into the procedures.
          </div>
          <div className="desc">
            Preparing a perfect CDR or RPL report requires meeting several technical requirements, which can be challenging. From selecting the right topics for your career
            episodes and adhering to the MSA booklet guidelines to following the Engineers Australia format and criteria, our tutoring sessions ensure you are well-equipped for the
            task. Similarly, while writing an RPL report, our experts provide guidance on aligning job descriptions with the ANZSCO code, selecting appropriate projects, and
            incorporating the necessary technical details.
          </div>
          <div className="desc">
            Many intricate technical aspects go into drafting these documents, which cannot always be addressed through general guidance. Our 1-to-1 tutoring sessions are tailored
            to cover every detail, ensuring you gain the knowledge and skills needed to prepare a successful CDR or RPL report.
          </div>

          <div className="header">How Do We Tutor You?</div>
          <div className="desc">
            Our tutoring service begins by understanding the specific requirements of your document and guiding you through all the technical aspects necessary for drafting it
            successfully. We ensure that every section is crafted seamlessly through personalized, step-by-step guidance tailored to your needs.
          </div>
          <div className="desc">
            Our Professional CDR Tutoring service includes the following:
            <ul>
              <li>Personalized CDR Reports Discussion Sessions with Professionals</li>
              <li>Online Consultation on How to Write an Impressive CDR Report</li>
              <li>Career Episodes Tutoring and Detailed Discussions</li>
            </ul>
          </div>
        </div>
      </div>
      <Contact />
      <Hire />
    </div>
  );
};

export default Tutoring;
